module.exports = __webpack_public_path__ + "media/images/layouts/theatre-ff6031aa1424f19d6b4f460ce73ab17a.png";